
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexlOQXz4qHz1_tjzzS__aw5L3qkduUse1pUPQ2t0gdaSoMeta } from "/src/app/pages/index.vue?macro=true";
import { default as previewLzs2TVoag_DQa4xR0UjFATnWdqQGUd_VuEty3Zn5UaQMeta } from "/src/app/pages/preview.vue?macro=true";
import { default as indexZV6uvHGRPI0oFcsOzCxx_s_V4nYUlOUlg_0FGoQqSwIMeta } from "/src/app/pages/bot/index.vue?macro=true";
import { default as indexv4gkkCmslGj9ELnUKUTCvSIhSSej8vQbp4_H6uO4SSMMeta } from "/src/app/pages/gift/index.vue?macro=true";
import { default as indexj6KziSTJegBd6F1qATTDXn4TOresxgumEovP5Wy7Y_IMeta } from "/src/app/pages/pass/index.vue?macro=true";
import { default as _91slug_93kdc5pbt5j0FkxkrOla1yrRp9znDksbeDM08rhK2ganMMeta } from "/src/app/pages/page/[slug].vue?macro=true";
import { default as confirmCmN_Yjg0n7U5lv8ELaFqF2QjlnLFcFDeHuyzIqW5w90Meta } from "/src/app/pages/pass/confirm.vue?macro=true";
import { default as _91id_93Z2wdjEdH7sfguQl7QtuL56Q0BeAhRB0JfePJQORbqTwMeta } from "/src/app/pages/service/[id].vue?macro=true";
import { default as indexoFXWctNEBv5d2NTb_hJn02CQr6rWP3oGXGZiHn3EilYMeta } from "/src/app/pages/widget/index.vue?macro=true";
import { default as indexT4bRIj14yoP4McL2gZYZLRJkR3_7vWqc4XQkNrVfqgwMeta } from "/src/app/pages/gallery/index.vue?macro=true";
import { default as complete1Bk6lw4ELI_g1aTarTpaBzGcALVAiSPDDFGo0j7HBowMeta } from "/src/app/pages/pass/complete.vue?macro=true";
import { default as customerpSxucljWgvc5IRG_qFdkKdgCLdSduPkgacA5GkRJIhsMeta } from "/src/app/pages/pass/customer.vue?macro=true";
import { default as indexxWDmjIjIodcn4eNRMwDnQBv38awIG5fjBeeYyOPZB4gMeta } from "/src/app/pages/reviews/index.vue?macro=true";
import { default as indexX7LplnB0qDcrCAEdI3ZkheFIK_yfBIL7tYA8QdJkReQMeta } from "/src/app/pages/book-now/index.vue?macro=true";
import { default as indexVyq32YJh0b_brcA0z1byNUK4E4BXqWOiuc_BiCfHVEYMeta } from "/src/app/pages/customer/index.vue?macro=true";
import { default as resetEUL_qwUI4YE7K2d0PZHQbiDzMjZUE4j3dO9IZe5m5VkMeta } from "/src/app/pages/customer/reset.vue?macro=true";
import { default as detailKPzgzUACZYfe4C8h7ZcGV_PrPRYJSshjJQI15D8gkmkMeta } from "/src/app/pages/book-now/detail.vue?macro=true";
import { default as logoutEjSeV_PyGkodQDHjshM2mkgY1u2Y4qVfZtRVDNd9uKQMeta } from "/src/app/pages/customer/logout.vue?macro=true";
import { default as claimzewcDn9C08EzpvBx_ZHnMYEfxK1EUGKu17U4AajtlzwMeta } from "/src/app/pages/gift/card/claim.vue?macro=true";
import { default as indexgIHWUjKhzK8EYf1OCnOzotz0_LQz1g_90YjX_9m92Z8Meta } from "/src/app/pages/gift/card/index.vue?macro=true";
import { default as claimZ6pnfqQBTbME56Yg4o18cThTMUBPidEg_miEQ51SJsAMeta } from "/src/app/pages/gift/pass/claim.vue?macro=true";
import { default as indexd6Ph4_yM_PxdV4CpB_auPWEI59Cbptpa3Sq2R1Ft6_cMeta } from "/src/app/pages/gift/pass/index.vue?macro=true";
import { default as index2NpX72aw7LyKSg59H8NzqYobx87foB59MY0mb_zWVgkMeta } from "/src/app/pages/timetable/index.vue?macro=true";
import { default as disabledjn04kguFygMedmFo6_1Q3WXsGefMmM50NI3_abtDuaoMeta } from "/src/app/pages/widget/disabled.vue?macro=true";
import { default as confirmOT2ElNNhFMuQ1gsOCf72sth_Fl0iHMM02cEwK2PBRSEMeta } from "/src/app/pages/book-now/confirm.vue?macro=true";
import { default as detailsXnM3ibCJHzz9147cBDQdEPjFgmdab_42GfclaOSloEUMeta } from "/src/app/pages/customer/details.vue?macro=true";
import { default as callback2zYrcg3SXWUhzxTBXKtKT5xO34iwAV1N4P0drcibUfYMeta } from "/src/app/pages/payment/callback.vue?macro=true";
import { default as completeRQ_kHfcGm67fxOasspfqE_VaV5zVWcJuFuU9SDHxZfMMeta } from "/src/app/pages/book-now/complete.vue?macro=true";
import { default as customerA42lIUqneGX7MNHUtCSj0VbPIdvrPeR8HV87q0mP_nIMeta } from "/src/app/pages/book-now/customer.vue?macro=true";
import { default as recoveryHVx_DKL1ABNzR7cShPpjZ3f1Z17rFBaW_q9UU9DYCxoMeta } from "/src/app/pages/customer/recovery.vue?macro=true";
import { default as waitlistwYKb6PUsXIcxVFu_KQWHr9eDl3KWgAWoNC_f95XQ_aUMeta } from "/src/app/pages/customer/waitlist.vue?macro=true";
import { default as confirmlD0TRdJqpRstuJI8lHgLBFAdqa7S14iAENuaLxiuwjEMeta } from "/src/app/pages/gift/card/confirm.vue?macro=true";
import { default as previewXHoRFwXelP4KJSzt5Z2Tb7ZLCw_mUL8uybeoAwGp95oMeta } from "/src/app/pages/gift/card/preview.vue?macro=true";
import { default as confirmFHKFGjB1qJpFlAN5trqWE7h5OKE6K7dEPGGEIEH4wJEMeta } from "/src/app/pages/gift/pass/confirm.vue?macro=true";
import { default as indexWK0arK7HUICus_xpEwvFBBZ4wbi_3P2clO1L1AJqnp8Meta } from "/src/app/pages/last-minute/index.vue?macro=true";
import { default as unsubscribeHlnuNIOyYVBjUTChTBK5iWTgKsG7moldbXOuTJmbJp0Meta } from "/src/app/pages/emails/unsubscribe.vue?macro=true";
import { default as complete_1wyeDJ85_RCRMFl87zHcG_FJ0__TwehjHN6q8Y8ulsMeta } from "/src/app/pages/gift/card/complete.vue?macro=true";
import { default as customerkZfbF5C1ooNF7Ai8fP0gjKsg_jNse1NKp9ZJMJV585MMeta } from "/src/app/pages/gift/card/customer.vue?macro=true";
import { default as completeWtx_BPMNhz41HfQLHDHYHWPsTF2J_hPoM21htVeRwGQMeta } from "/src/app/pages/gift/pass/complete.vue?macro=true";
import { default as customerCQuLuRD2fv__eteIF8l6UD_KZYzcJwp_q_opZ2Ce6W8Meta } from "/src/app/pages/gift/pass/customer.vue?macro=true";
import { default as code27zH2_wmWAQJtO6mdz3OiZ099bUpcxIT0WQA0zwTZT4Meta } from "/src/app/pages/customer/login/code.vue?macro=true";
import { default as indexwWnZ1p_6s0MpeYGJ9WZC_qaZVb32V4KLwm20NrXE_HUMeta } from "/src/app/pages/customer/pass/index.vue?macro=true";
import { default as indexhb6_ZRC8_S6wa7GZnSfzvW8E_DRWskFQxBUSe82VREsMeta } from "/src/app/pages/customer/sale/index.vue?macro=true";
import { default as unsupported_45browserhxCjxldyXKypnFEJc6FZPDrLOtUF3b9knDc14TKBNnEMeta } from "/src/app/pages/unsupported-browser.vue?macro=true";
import { default as submitDhMoCMEIF39hsORYRm2s0OskKVNPKTg0GG6L1xiOF9IMeta } from "/src/app/pages/customer/form/submit.vue?macro=true";
import { default as thanks6JuOmLQFcnpb_YTcg8piEsu8NT8yQMYHe0yRK2h59A0Meta } from "/src/app/pages/customer/form/thanks.vue?macro=true";
import { default as email51GUOMT0h8aDhhoBvWf_tJKWp_fZUrzUgU_brAldwD8Meta } from "/src/app/pages/customer/login/email.vue?macro=true";
import { default as indextQ9e1L0g3yhQOufDx_z5pJagxnzF50ImRv1IJTnWXLcMeta } from "/src/app/pages/customer/login/index.vue?macro=true";
import { default as availability5ezgKWZWvf5A4VST718WZo0yUvHFS_DDiSz2z6iWDREMeta } from "/src/app/pages/book-now/availability.vue?macro=true";
import { default as _91id_93_OXgS_0Lj3uRG5PVZTkAS1TTjxsfNXdW1zPgfCDcYg4Meta } from "/src/app/pages/book-now/service/[id].vue?macro=true";
import { default as paymentSJdGwGbe5dfxSImevizk6yjHpqXF1PJy91nN5MvusqUMeta } from "/src/app/pages/customer/sale/payment.vue?macro=true";
import { default as _91id_93NKsHYagrBcyrgebDAQDpy0uwLiroxFKswMkJ7hvqBqEMeta } from "/src/app/pages/book-now/category/[id].vue?macro=true";
import { default as expiredKABPcWeuhNRutcohUQAcf0pAY__5J0g_INIPYHgoi00Meta } from "/src/app/pages/customer/login/expired.vue?macro=true";
import { default as index9Z5d8kOYcKAsWILAL_vti6mBrqhfvWSe9DQpIP4VGVIMeta } from "/src/app/pages/customer/giftcard/index.vue?macro=true";
import { default as indexci6_ZJU_fPPr899ZqggcnItSOq2eroJRsY8Y9jHK91cMeta } from "/src/app/pages/customer/register/index.vue?macro=true";
import { default as success9RN94N75JJZU7mxnz_LqLWiwZ9XHcKx1B2nG6JfCfMYMeta } from "/src/app/pages/customer/register/success.vue?macro=true";
import { default as completeWHr0OP_WXpGR0sh1j3MKIMaGhHMRtqZwEpYxMPz8hD0Meta } from "/src/app/pages/book-now/waitlist/complete.vue?macro=true";
import { default as customer8TX9gldm4kz2_wgdgRSb9w7X9rxYL5gcSM43zE7HqBIMeta } from "/src/app/pages/book-now/waitlist/customer.vue?macro=true";
import { default as indexq0sgBXjIngLZdGAx_LOs9_pb7OtkAGHhfQImXiRuFWwMeta } from "/src/app/pages/customer/reservation/index.vue?macro=true";
import { default as reviewk9dIYev5RPpAZq9zfYUwcH8AlC7iWk_5ApDc4SviELwMeta } from "/src/app/pages/customer/reservation/review.vue?macro=true";
import { default as confirmIE6_Smzi_iDrR21vPX2xVFvYQ_HkS40HyLjCCd3iI_IMeta } from "/src/app/pages/customer/reservation/confirm.vue?macro=true";
import { default as availabilityK2PDD31_6_UMsd_Fo6aDk0NX3JFTIXbvFMWlm9lA_8gMeta } from "/src/app/pages/book-now/waitlist/availability.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/src/app/pages/index.vue")
  },
  {
    name: "preview",
    path: "/preview",
    meta: previewLzs2TVoag_DQa4xR0UjFATnWdqQGUd_VuEty3Zn5UaQMeta || {},
    component: () => import("/src/app/pages/preview.vue")
  },
  {
    name: "bot",
    path: "/bot",
    component: () => import("/src/app/pages/bot/index.vue")
  },
  {
    name: "gift",
    path: "/gift",
    meta: indexv4gkkCmslGj9ELnUKUTCvSIhSSej8vQbp4_H6uO4SSMMeta || {},
    component: () => import("/src/app/pages/gift/index.vue")
  },
  {
    name: "pass",
    path: "/pass",
    component: () => import("/src/app/pages/pass/index.vue")
  },
  {
    name: "page-slug",
    path: "/page/:slug()",
    component: () => import("/src/app/pages/page/[slug].vue")
  },
  {
    name: "pass-confirm",
    path: "/pass/confirm",
    component: () => import("/src/app/pages/pass/confirm.vue")
  },
  {
    name: "service-id",
    path: "/service/:id()",
    component: () => import("/src/app/pages/service/[id].vue")
  },
  {
    name: "widget",
    path: "/widget",
    meta: {"middleware":["widget"]},
    component: () => import("/src/app/pages/widget/index.vue")
  },
  {
    name: "gallery",
    path: "/gallery",
    meta: { ...(indexT4bRIj14yoP4McL2gZYZLRJkR3_7vWqc4XQkNrVfqgwMeta || {}), ...{"middleware":["redirects"]} },
    component: () => import("/src/app/pages/gallery/index.vue")
  },
  {
    name: "pass-complete",
    path: "/pass/complete",
    component: () => import("/src/app/pages/pass/complete.vue")
  },
  {
    name: "pass-customer",
    path: "/pass/customer",
    component: () => import("/src/app/pages/pass/customer.vue")
  },
  {
    name: "reviews",
    path: "/reviews",
    meta: indexxWDmjIjIodcn4eNRMwDnQBv38awIG5fjBeeYyOPZB4gMeta || {},
    component: () => import("/src/app/pages/reviews/index.vue")
  },
  {
    name: "book-now",
    path: "/book-now",
    component: () => import("/src/app/pages/book-now/index.vue")
  },
  {
    name: "customer",
    path: "/customer",
    meta: { ...(indexVyq32YJh0b_brcA0z1byNUK4E4BXqWOiuc_BiCfHVEYMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/src/app/pages/customer/index.vue")
  },
  {
    name: "customer-reset",
    path: "/customer/reset",
    meta: resetEUL_qwUI4YE7K2d0PZHQbiDzMjZUE4j3dO9IZe5m5VkMeta || {},
    component: () => import("/src/app/pages/customer/reset.vue")
  },
  {
    name: "book-now-detail",
    path: "/book-now/detail",
    meta: { ...(detailKPzgzUACZYfe4C8h7ZcGV_PrPRYJSshjJQI15D8gkmkMeta || {}), ...{"middleware":["redirects"]} },
    component: () => import("/src/app/pages/book-now/detail.vue")
  },
  {
    name: "customer-logout",
    path: "/customer/logout",
    meta: { ...(logoutEjSeV_PyGkodQDHjshM2mkgY1u2Y4qVfZtRVDNd9uKQMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/src/app/pages/customer/logout.vue")
  },
  {
    name: "gift-card-claim",
    path: "/gift/card/claim",
    meta: claimzewcDn9C08EzpvBx_ZHnMYEfxK1EUGKu17U4AajtlzwMeta || {},
    component: () => import("/src/app/pages/gift/card/claim.vue")
  },
  {
    name: "gift-card",
    path: "/gift/card",
    meta: { ...(indexgIHWUjKhzK8EYf1OCnOzotz0_LQz1g_90YjX_9m92Z8Meta || {}), ...{"middleware":["redirects"]} },
    component: () => import("/src/app/pages/gift/card/index.vue")
  },
  {
    name: "gift-pass-claim",
    path: "/gift/pass/claim",
    meta: claimZ6pnfqQBTbME56Yg4o18cThTMUBPidEg_miEQ51SJsAMeta || {},
    component: () => import("/src/app/pages/gift/pass/claim.vue")
  },
  {
    name: "gift-pass",
    path: "/gift/pass",
    meta: { ...(indexd6Ph4_yM_PxdV4CpB_auPWEI59Cbptpa3Sq2R1Ft6_cMeta || {}), ...{"middleware":["redirects"]} },
    component: () => import("/src/app/pages/gift/pass/index.vue")
  },
  {
    name: "timetable",
    path: "/timetable",
    meta: { ...(index2NpX72aw7LyKSg59H8NzqYobx87foB59MY0mb_zWVgkMeta || {}), ...{"middleware":["redirects"]} },
    component: () => import("/src/app/pages/timetable/index.vue")
  },
  {
    name: "widget-disabled",
    path: "/widget/disabled",
    meta: {"middleware":["widget"]},
    component: () => import("/src/app/pages/widget/disabled.vue")
  },
  {
    name: "book-now-confirm",
    path: "/book-now/confirm",
    meta: { ...(confirmOT2ElNNhFMuQ1gsOCf72sth_Fl0iHMM02cEwK2PBRSEMeta || {}), ...{"middleware":["redirects"]} },
    component: () => import("/src/app/pages/book-now/confirm.vue")
  },
  {
    name: "customer-details",
    path: "/customer/details",
    meta: { ...(detailsXnM3ibCJHzz9147cBDQdEPjFgmdab_42GfclaOSloEUMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/src/app/pages/customer/details.vue")
  },
  {
    name: "payment-callback",
    path: "/payment/callback",
    component: () => import("/src/app/pages/payment/callback.vue")
  },
  {
    name: "book-now-complete",
    path: "/book-now/complete",
    meta: { ...(completeRQ_kHfcGm67fxOasspfqE_VaV5zVWcJuFuU9SDHxZfMMeta || {}), ...{"middleware":["redirects"]} },
    component: () => import("/src/app/pages/book-now/complete.vue")
  },
  {
    name: "book-now-customer",
    path: "/book-now/customer",
    meta: { ...(customerA42lIUqneGX7MNHUtCSj0VbPIdvrPeR8HV87q0mP_nIMeta || {}), ...{"middleware":["redirects"]} },
    component: () => import("/src/app/pages/book-now/customer.vue")
  },
  {
    name: "customer-recovery",
    path: "/customer/recovery",
    meta: recoveryHVx_DKL1ABNzR7cShPpjZ3f1Z17rFBaW_q9UU9DYCxoMeta || {},
    component: () => import("/src/app/pages/customer/recovery.vue")
  },
  {
    name: "customer-waitlist",
    path: "/customer/waitlist",
    meta: { ...(waitlistwYKb6PUsXIcxVFu_KQWHr9eDl3KWgAWoNC_f95XQ_aUMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/src/app/pages/customer/waitlist.vue")
  },
  {
    name: "gift-card-confirm",
    path: "/gift/card/confirm",
    meta: confirmlD0TRdJqpRstuJI8lHgLBFAdqa7S14iAENuaLxiuwjEMeta || {},
    component: () => import("/src/app/pages/gift/card/confirm.vue")
  },
  {
    name: "gift-card-preview",
    path: "/gift/card/preview",
    meta: previewXHoRFwXelP4KJSzt5Z2Tb7ZLCw_mUL8uybeoAwGp95oMeta || {},
    component: () => import("/src/app/pages/gift/card/preview.vue")
  },
  {
    name: "gift-pass-confirm",
    path: "/gift/pass/confirm",
    meta: confirmFHKFGjB1qJpFlAN5trqWE7h5OKE6K7dEPGGEIEH4wJEMeta || {},
    component: () => import("/src/app/pages/gift/pass/confirm.vue")
  },
  {
    name: "last-minute",
    path: "/last-minute",
    meta: { ...(indexWK0arK7HUICus_xpEwvFBBZ4wbi_3P2clO1L1AJqnp8Meta || {}), ...{"middleware":["redirects"]} },
    component: () => import("/src/app/pages/last-minute/index.vue")
  },
  {
    name: "emails-unsubscribe",
    path: "/emails/unsubscribe",
    component: () => import("/src/app/pages/emails/unsubscribe.vue")
  },
  {
    name: "gift-card-complete",
    path: "/gift/card/complete",
    meta: complete_1wyeDJ85_RCRMFl87zHcG_FJ0__TwehjHN6q8Y8ulsMeta || {},
    component: () => import("/src/app/pages/gift/card/complete.vue")
  },
  {
    name: "gift-card-customer",
    path: "/gift/card/customer",
    meta: customerkZfbF5C1ooNF7Ai8fP0gjKsg_jNse1NKp9ZJMJV585MMeta || {},
    component: () => import("/src/app/pages/gift/card/customer.vue")
  },
  {
    name: "gift-pass-complete",
    path: "/gift/pass/complete",
    meta: completeWtx_BPMNhz41HfQLHDHYHWPsTF2J_hPoM21htVeRwGQMeta || {},
    component: () => import("/src/app/pages/gift/pass/complete.vue")
  },
  {
    name: "gift-pass-customer",
    path: "/gift/pass/customer",
    meta: customerCQuLuRD2fv__eteIF8l6UD_KZYzcJwp_q_opZ2Ce6W8Meta || {},
    component: () => import("/src/app/pages/gift/pass/customer.vue")
  },
  {
    name: "customer-login-code",
    path: "/customer/login/code",
    meta: code27zH2_wmWAQJtO6mdz3OiZ099bUpcxIT0WQA0zwTZT4Meta || {},
    component: () => import("/src/app/pages/customer/login/code.vue")
  },
  {
    name: "customer-pass",
    path: "/customer/pass",
    component: () => import("/src/app/pages/customer/pass/index.vue")
  },
  {
    name: "customer-sale",
    path: "/customer/sale",
    meta: { ...(indexhb6_ZRC8_S6wa7GZnSfzvW8E_DRWskFQxBUSe82VREsMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/src/app/pages/customer/sale/index.vue")
  },
  {
    name: "unsupported-browser",
    path: "/unsupported-browser",
    meta: unsupported_45browserhxCjxldyXKypnFEJc6FZPDrLOtUF3b9knDc14TKBNnEMeta || {},
    component: () => import("/src/app/pages/unsupported-browser.vue")
  },
  {
    name: "customer-form-submit",
    path: "/customer/form/submit",
    meta: { ...(submitDhMoCMEIF39hsORYRm2s0OskKVNPKTg0GG6L1xiOF9IMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/src/app/pages/customer/form/submit.vue")
  },
  {
    name: "customer-form-thanks",
    path: "/customer/form/thanks",
    meta: { ...(thanks6JuOmLQFcnpb_YTcg8piEsu8NT8yQMYHe0yRK2h59A0Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/src/app/pages/customer/form/thanks.vue")
  },
  {
    name: "customer-login-email",
    path: "/customer/login/email",
    meta: email51GUOMT0h8aDhhoBvWf_tJKWp_fZUrzUgU_brAldwD8Meta || {},
    component: () => import("/src/app/pages/customer/login/email.vue")
  },
  {
    name: "customer-login",
    path: "/customer/login",
    meta: indextQ9e1L0g3yhQOufDx_z5pJagxnzF50ImRv1IJTnWXLcMeta || {},
    component: () => import("/src/app/pages/customer/login/index.vue")
  },
  {
    name: "book-now-availability",
    path: "/book-now/availability",
    meta: { ...(availability5ezgKWZWvf5A4VST718WZo0yUvHFS_DDiSz2z6iWDREMeta || {}), ...{"middleware":["redirects"]} },
    component: () => import("/src/app/pages/book-now/availability.vue")
  },
  {
    name: "book-now-service-id",
    path: "/book-now/service/:id()",
    meta: {"middleware":["service"]},
    component: () => import("/src/app/pages/book-now/service/[id].vue")
  },
  {
    name: "customer-sale-payment",
    path: "/customer/sale/payment",
    meta: { ...(paymentSJdGwGbe5dfxSImevizk6yjHpqXF1PJy91nN5MvusqUMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/src/app/pages/customer/sale/payment.vue")
  },
  {
    name: "book-now-category-id",
    path: "/book-now/category/:id()",
    meta: {"middleware":["category"]},
    component: () => import("/src/app/pages/book-now/category/[id].vue")
  },
  {
    name: "customer-login-expired",
    path: "/customer/login/expired",
    meta: expiredKABPcWeuhNRutcohUQAcf0pAY__5J0g_INIPYHgoi00Meta || {},
    component: () => import("/src/app/pages/customer/login/expired.vue")
  },
  {
    name: "customer-giftcard",
    path: "/customer/giftcard",
    meta: { ...(index9Z5d8kOYcKAsWILAL_vti6mBrqhfvWSe9DQpIP4VGVIMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/src/app/pages/customer/giftcard/index.vue")
  },
  {
    name: "customer-register",
    path: "/customer/register",
    meta: { ...(indexci6_ZJU_fPPr899ZqggcnItSOq2eroJRsY8Y9jHK91cMeta || {}), ...{"middleware":["redirects","register"]} },
    component: () => import("/src/app/pages/customer/register/index.vue")
  },
  {
    name: "customer-register-success",
    path: "/customer/register/success",
    component: () => import("/src/app/pages/customer/register/success.vue")
  },
  {
    name: "book-now-waitlist-complete",
    path: "/book-now/waitlist/complete",
    component: () => import("/src/app/pages/book-now/waitlist/complete.vue")
  },
  {
    name: "book-now-waitlist-customer",
    path: "/book-now/waitlist/customer",
    meta: { ...(customer8TX9gldm4kz2_wgdgRSb9w7X9rxYL5gcSM43zE7HqBIMeta || {}), ...{"middleware":["redirects"]} },
    component: () => import("/src/app/pages/book-now/waitlist/customer.vue")
  },
  {
    name: "customer-reservation",
    path: "/customer/reservation",
    meta: { ...(indexq0sgBXjIngLZdGAx_LOs9_pb7OtkAGHhfQImXiRuFWwMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/src/app/pages/customer/reservation/index.vue")
  },
  {
    name: "customer-reservation-review",
    path: "/customer/reservation/review",
    meta: { ...(reviewk9dIYev5RPpAZq9zfYUwcH8AlC7iWk_5ApDc4SviELwMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/src/app/pages/customer/reservation/review.vue")
  },
  {
    name: "customer-reservation-confirm",
    path: "/customer/reservation/confirm",
    meta: { ...(confirmIE6_Smzi_iDrR21vPX2xVFvYQ_HkS40HyLjCCd3iI_IMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/src/app/pages/customer/reservation/confirm.vue")
  },
  {
    name: "book-now-waitlist-availability",
    path: "/book-now/waitlist/availability",
    component: () => import("/src/app/pages/book-now/waitlist/availability.vue")
  }
]